import React from 'react';
import { Image, View } from 'react-native';
import { designConstants } from '../../design/styles';
import { Text } from '../../design/components';
import * as Animatable from 'react-native-animatable';
import SeverityCircle from './SeverityCircle';
import { withTheme } from '../../design/styles/useThemeContext';

class Counter extends React.PureComponent {
  render() {
    const { severityMode, onCheckPressed, value, selected } = this.props;
    const { colors } = this.props.theme;
    const isInteger = Number.isInteger(value);
    const checkMark = value
      ? require('./general_icon_checkmark_new.png')
      : require('./general_icon_no_checkmark.png');
    const isTablet = designConstants.isTablet();

    if (isTablet && severityMode) {
      return (
        !selected && (
          <SeverityCircle
            size={30}
            value={value}
            mode={severityMode}
            style={{ marginRight: designConstants.paddings.edgePadding }}
          />
        )
      );
    }

    if (isInteger) {
      return (
        !onCheckPressed &&
        !severityMode && (
          <View
            style={{
              width: 24,
              height: 24,
              borderRadius: 12,
              backgroundColor:
                value > 0 ? colors.lightGreen : colors.defaultBackground,
              marginRight: 0,
            }}
          >
            <Text
              small
              style={{
                color: colors.white,
                textAlign: 'center',
                alignSelf: 'center',
                marginTop: 4,
              }}
            >
              {value || ''}
            </Text>
          </View>
        )
      );
    }
    return (
      !onCheckPressed &&
      !severityMode && (
        <Image
          source={checkMark}
          style={{
            width: 24,
            height: 24,
            marginRight: 0,
            resizeMode: 'center',
          }}
        />
      )
    );
  }
}

export default withTheme(Counter);
